module.exports = __webpack_public_path__ + "img/ring_0_0_null_null@3x.d4b0774e.png";